module.exports = __webpack_public_path__ + "static/media/img-55.e1a44bb0.jpg";